import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer-pagetop-button" }
const _hoisted_2 = { class: "footer-contents" }
const _hoisted_3 = { class: "footer-contents-nav" }
const _hoisted_4 = {
  class: "footer-contents-nav-list",
  id: "footer_link_list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "footer-contents-nav-list-items" }
const _hoisted_7 = { class: "footer-contents-nav-list-items" }
const _hoisted_8 = { class: "footer-copylight" }
const _hoisted_9 = { class: "footer-copylight-text" }
const _hoisted_10 = { class: "sp-footer-copylight" }
const _hoisted_11 = { class: "copylight-text" }
const _hoisted_12 = { class: "sp-footer-nav" }
const _hoisted_13 = { class: "footer-nav-contents" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "footer-nav-contents-text" }
const _hoisted_16 = {
  key: 0,
  class: "badge-new",
  src: "/server/necs/images/badge_new.svg",
  alt: ""
}

import { ref } from "vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    scrollTarget: {},
    activeMenu: {}
  },
  setup(__props: any) {

const router = useRouter();

const props = __props;

// 下部グロナビで固定NEWバッジを表示するメニュー
const FIXED_NEW_BADGE_MENU_IDS = [];

const currentYear = ref(new Date().getFullYear());

const bottomNavItems = [
  {
    menuId: "home",
    name: "footer_nav_home",
    route: "home",
  },
  // {
  //   menuId: "Community",
  //   name: "footer_nav_info_exchange",
  //   route: "Community",
  // },
  {
    menuId: "article",
    name: "footer_nav_article",
    route: "article",
  },
  {
    menuId: "my-record",
    name: "footer_nav_record",
    route: "MyRecord",
  },
  {
    menuId: "my-report",
    name: "footer_nav_report",
    route: "MyReport",
  },
];

const scrollToTarget = () => {
  const element = document.getElementById(props.scrollTarget);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const openLink = (route: string) => {
  router.push({ name: route });
};

const openContactForm = () => {
  window.open(
    "https://web.gogo.jp/kanshin-hiroba/form/contact-member",
    "_blank"
  );
};

const openPrivacyPolicy = () => {
  window.open("https://www.kanshin-hiroba.jp/privacy-policy", "_blank");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "footer-separator-line" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: "#",
        onClick: _withModifiers(scrollToTarget, ["prevent"])
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "/server/necs/images/footer-pagetop.png",
          alt: "Page Top"
        }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"footer-contents-logo\"><a href=\"#\" class=\"home\"><img src=\"/server/necs/images/kanshin_logo.png\" alt=\"Footer Logo\"></a><a href=\"https://www.kanshin-hiroba.jp/\" class=\"small-banner\" target=\"_blank\"><img src=\"/server/necs/images/kanshin-hiroba_banner.png\" alt=\"Footer Logo\"></a><a href=\"https://www.byokijiten.com/\" class=\"small-banner\" target=\"_blank\"><img src=\"/server/necs/images/byokijiten_banner.png\" alt=\"Footer Logo\"></a></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bottomNavItems, (item) => {
            return _createElementVNode("li", {
              class: "footer-contents-nav-list-items",
              key: item.menuId
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "arrow" }, null, -1)),
              _createElementVNode("span", {
                onClick: ($event: any) => (openLink(item.route))
              }, _toDisplayString(item.menuId === "my-report"
                  ? _ctx.$t("header_nav_report")
                  : _ctx.$t(item.name)), 9, _hoisted_5)
            ])
          }), 64)),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("span", {
              class: "contents-links",
              onClick: openContactForm
            }, _toDisplayString(_ctx.$t("footer_contact_form")), 1)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("span", {
              class: "contents-links",
              onClick: openPrivacyPolicy
            }, _toDisplayString(_ctx.$t("footer_privacy_policy")), 1)
          ])
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "footer-cover-img" }, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("footer_copyright", { year: currentYear.value })), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("footer_copyright", { year: currentYear.value })), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("ul", _hoisted_13, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bottomNavItems, (item) => {
          return _createElementVNode("li", {
            class: _normalizeClass(["footer-nav-contents-item", [
            item.menuId === 'Community' ? 'summary' : item.menuId,
            { active: item.menuId === props.activeMenu },
          ]]),
            key: item.menuId,
            onClick: ($event: any) => (openLink(item.route))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "footer-nav-contents-icon" }, null, -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(item.name)), 1),
            (FIXED_NEW_BADGE_MENU_IDS.includes(item.menuId))
              ? (_openBlock(), _createElementBlock("img", _hoisted_16))
              : _createCommentVNode("", true)
          ], 10, _hoisted_14)
        }), 64))
      ])
    ])
  ]))
}
}

})